// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"ContextMenu_contextMenu__EdXJ5","menuItem":"ContextMenu_menuItem__3nHC4"};